import React, { memo, useCallback, useRef, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { message } from 'antd';
import classNames from 'classnames';
import styles from './Setting.module.less';
import WallpaperPath from './WallpaperPath';
import { PCStoreJsBridge } from '../../nativeapi';
import {
  setOtherInfo,
  setQuietInstallPath,
  setUpdateNotifyStatus,
  setResidualNotifyStatus,
  setRarelyNotifyStatus,
} from '../../actions/native';
import { setDownloadPathVisible, setIsEnabledSilent } from '../../actions/layout';
import { logging } from '../../actions/log';
import { cacheKeys } from '../../constants/storageKeys';
import { logNative } from '../../utils/utils';
import Dialog from '../../components/Dialog/Dialog';
import Btn from '../../components/Btn/Btn';
import fail from '../../static/msg-fail.svg';
import Toast from '../../components/Toast/Toast';
import OpenWelcome from './OpenWelcome';
import UnknownFile from './UnknownFile';
import WallpaperChange from './WallpaperChange';
import MessageHint from './MessageHint';

const selectOtherInfo = createSelector(
  state => state.native,
  native => native.otherInfo,
);

const selectQuietInstallPath = createSelector(
  state => state.native,
  native => native.quietInstallPath,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectSystemType = createSelector(
  state => state.layout,
  layout => layout.systemType,
);

let timeoutSystemType = false;
export default memo(() => {
  const dispatch = useDispatch();
  const otherInfo = useSelector(selectOtherInfo);
  const quietInstallPath = useSelector(selectQuietInstallPath);
  const logInfoData = useSelector(selectLogInfo);
  const systemType = useSelector(selectSystemType); // 系统模式

  const inputRef = useRef();
  const inputRefQuiet = useRef();

  let clearSpanDay = 7;
  // 是否打开自动升级商店
  const [isEnabledAutoUpdate, setIsEnabledAutoUpdate] = useState(true);
  // 是否打开右键菜单开关
  const [rightMenuInfo, setRightMenuInfo] = useState({});
  // 是否打开右键菜单开关
  const [isDStore, setIsDStore] = useState(false);
  // 是否clearSpanDay天自动清除
  const [isEnabledClear, setIsEnabledClear] = useState(false);
  // 是否卸载磁铁
  const [isEnabledTileInfo, setIsEnabledTileInfo] = useState({});
  const [isEnabled, setIsEnabled] = useState(true);
  const [pathValue, setPathValue] = useState('');
  const [pathValueQuiet, setPathValueQuiet] = useState('');

  // 是否展示更多选项
  const [foldPanel, setFoldPanel] = useState(true);
  // 当前操作的
  const [switchType, setSwitchType] = useState(null);
  // 是否升级弹窗
  const [isEnabledUpdate, setIsEnabledUpdate] = useState(false);
  // 是否右键
  const [isEnabledRight, setIsEnabledRight] = useState(false);
  // 是否残留弹窗
  const [isEnabledResidual, setIsEnabledResidual] = useState(false);
  // 是否不常用弹框
  const [isEnabledRarelyUse, setIsEnabledRarelyUse] = useState(false);
  // 是否恢复系统默认模式
  const [isEnabledSystemType, setIsEnabledSystemType] = useState(false);

  const switchInfo = {
    1: {
      type: 1,
      isEnabled: isEnabledUpdate,
      modalInfo: '关闭升级弹窗提醒，可能会错过重要软件更新，确认是否要关闭？',
    },
    2: {
      type: 2,
      isEnabled: isEnabledRight,
      modalInfo: '建议您开启右键菜单',
    },
    3: {
      type: 3,
      isEnabled: isEnabledResidual,
      modalInfo: '建议您开启卸载残留提醒，及时清理残留，释放空间。确认是否要关闭？',
    },
    4: {
      type: 4,
      isEnabled: isEnabledRarelyUse,
      modalInfo: '建议您开启不常用软件提醒，及时管理我的软件。确认是否要关闭？',
    },
  };

  /**
   * 初始化 拿到设置数据
   */
  useEffect(() => {
    const startInfo = JSON.parse(localStorage.getItem(cacheKeys.START_INFO) || '{}');
    const enabled = localStorage.getItem(cacheKeys.ENABLE_QUICK_INSTALL) || '1';
    setIsEnabled(enabled === '' || enabled === '1');

    // 获取初始化的自动删除安装包状态
    setIsEnabledClear(startInfo.autoclean === 1);

    // 是否为独立包
    setIsDStore(startInfo.isDStore || false);

    clearSpanDay = startInfo.spanday;

    // 是否可自动升级商店，自动升级商店是否打开
    PCStoreJsBridge.getUpdatePCStoreState().then(res => {
      if (res) {
        setIsEnabledAutoUpdate(!!res.userQuietUpgrade);
      }
    });

    // 卸载磁铁
    if (startInfo && startInfo.storeTileInfo) {
      setIsEnabledTileInfo(startInfo.storeTileInfo);
    } else {
      PCStoreJsBridge.getPCStoreTileStatus().then(res => {
        if (res.succ) {
          setIsEnabledTileInfo({ enable: res.enable, cloudEnable: res.cloudEnable });
        }
      });
    }

    if (startInfo && startInfo.rightMenuInfo) {
      setRightMenuInfo(startInfo.rightMenuInfo);
    } else {
      // 这里设置右键菜单开关状态
      PCStoreJsBridge.getRightMenuInfo().then(res => {
        if (res.succ) {
          setRightMenuInfo(res);
        }
      });
    }
  }, []);

  // 初始化 拿到下载路径
  useEffect(() => {
    if (otherInfo) {
      setPathValue(otherInfo.DownLoadPath);
    }
  }, [otherInfo]);

  // 初始化 拿到静默安装路径
  useEffect(() => {
    if (quietInstallPath) {
      setPathValueQuiet(quietInstallPath.installpath);
    }
  }, [quietInstallPath]);

  useEffect(() => {
    getSwitchStatus({ type: 1 });
    // getSwitchStatus({ type: 2 });
    getSwitchStatus({ type: 3 });
    getSwitchStatus({ type: 4 });
  }, []);

  /**
   * @param {*} type
   * type: 1 升级弹框   2 右键菜单开关   3 卸载残留弹窗开关   4 不常用软件弹窗开关
   */
  const getSwitchStatus = param => {
    PCStoreJsBridge.getAppStoreSwitch({
      ...param,
    }).then(({ succ, enable }) => {
      if (succ) {
        if (param.type === 1) {
          setIsEnabledUpdate(!!enable);
          dispatch(setUpdateNotifyStatus(!!enable));
        }
        if (param.type === 2) {
          setIsEnabledRight(!!enable);
        }
        if (param.type === 3) {
          setIsEnabledResidual(!!enable);
          dispatch(setResidualNotifyStatus(!!enable));
        }
        if (param.type === 4) {
          setIsEnabledRarelyUse(!!enable);
          dispatch(setRarelyNotifyStatus(!!enable));
        }
      }
    });
  };

  /**
   * 点击关闭
   */
  const handleCancel = useCallback(() => {
    dispatch(setDownloadPathVisible(false));
  }, [dispatch]);

  // 打开某个路径
  const handleOpenFolder = useCallback(
    (path, type) => {
      PCStoreJsBridge.openFolder(path);
      // 点击 打开文件路径
      dispatch(
        logging({
          category: 'C',
          action: 'Open_Path',
          label: '',
          param2: {
            source: 'Setting',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            type, // 0: 普通安装  1：静默安装
          },
        }),
      );
    },
    [dispatch, logInfoData],
  );

  // 恢复下载路径
  const handleRecover = useCallback(() => {
    const DownLoadPath = otherInfo.DefaultPath;
    setPathValue(DownLoadPath);
    setTimeout(() => {
      submitDownloadPath();
    }, 100);

    // 点击 恢复默认文件路径
    dispatch(
      logging({
        category: 'C',
        action: 'Recover_Path',
        label: '',
        param2: {
          source: 'Setting',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type: '0', // 0: 普通安装  1：静默安装
        },
      }),
    );
  }, [dispatch, logInfoData]);

  // 设置下载路径
  const submitDownloadPath = useCallback(() => {
    const matchStrD = /^[(\u4e00-\u9fa5)|(0-9)|(a-z)|(A-Z)|(_)|( )|(\\)|(:)]+$/;
    // 设置下载路径
    const DownLoadPath = inputRef.current.value;
    if (!DownLoadPath.match(matchStrD)) {
      message.info('下载目录，请不要选择有特殊字符的文件夹');
      return;
    }
    // 设置下载路径
    PCStoreJsBridge.setDownloadPath(DownLoadPath).then(
      data => {
        if (data.code === 0) {
          dispatch(setOtherInfo({ DownLoadPath }));
          Toast.success({
            content: '下载软件路径，设置成功！',
          });
        } else {
          let msg = '下载路径设置失败！';
          if (data.code === 111) {
            msg = '下载软件路径，盘符不存在！';
          } else if (data.code === 110) {
            msg = '下载软件路径，磁盘空间不足！';
          }
          setPathValue(otherInfo.DefaultPath);
          Toast.error({ content: msg });
        }

        // 点击 打开选择下载文件路径
        dispatch(
          logging({
            category: 'R',
            action: 'Check_Path',
            label: '',
            param2: {
              source: 'Setting',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              type: '0', // 0: 普通安装  1：静默安装  2:壁纸下载路径
              status: data.code === 0,
            },
          }),
        );
      },
      err => {
        setPathValue(otherInfo.DefaultPath);
        Toast.error({
          content: '下载路径设置失败！',
        });
      },
    );
  }, [inputRef, otherInfo]);

  // 选择下载路径
  const handleBrowserFolder = useCallback(() => {
    const path = otherInfo.DownLoadPath || otherInfo.DefaultPath;
    PCStoreJsBridge.browserFolder(path).then(res => {
      setPathValue(res.DownLoadPath);
      setTimeout(() => {
        submitDownloadPath();
      }, 100);
    });

    // 点击 打开选择下载文件路径
    dispatch(
      logging({
        category: 'C',
        action: 'Check_Path',
        label: '',
        param2: {
          source: 'Setting',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type: '0',
        },
      }),
    );
  }, [dispatch, otherInfo]);

  // 选择是否打开静默安装
  const handleCheck = useCallback(enabled => {
    setIsEnabled(!enabled);

    // 设置是否取消快装
    localStorage.setItem(cacheKeys.ENABLE_QUICK_INSTALL, !enabled ? '1' : '0');
    dispatch(setIsEnabledSilent(!enabled));

    // 点击 切换打开快装
    dispatch(
      logging({
        category: 'C',
        action: 'Xpress_Cancel',
        label: '',
        param2: {
          source: 'Setting',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          enabled: !enabled,
        },
      }),
    );
  }, []);

  // 设置静默安装路径
  const submitQuietInstallPath = useCallback(() => {
    const matchStrI = /^[(\u4e00-\u9fa5)|(0-9)|(a-z)|(A-Z)|(_)|(\\)|(:)]+$/;
    // 设置安装路径
    const installpath = inputRefQuiet.current.value;
    if (!installpath.match(matchStrI)) {
      message.info('快装目录，请不要选择有空格或特殊字符的文件夹');
      return;
    }
    PCStoreJsBridge.setQuietInstallPath(installpath).then(
      data => {
        if (data.code === 0) {
          // 设置快装路径
          dispatch(
            setQuietInstallPath({
              ...quietInstallPath,
              installpath,
            }),
          );
          Toast.success({
            content: '软件静默安装路径，设置成功！',
          });
        } else {
          let msg = '软件静默安装路径，设置失败！';
          if (data.code === 111) {
            msg = '软件静默安装路径，盘符不存在！';
          } else if (data.code === 110) {
            msg = '软件静默安装路径，磁盘空间不足！';
          }
          setPathValueQuiet(quietInstallPath.installpath);
          Toast.error({ content: msg });
        }

        // 点击 打开选择下载文件路径
        dispatch(
          logging({
            category: 'R',
            action: 'Check_Path',
            label: '',
            param2: {
              source: 'Setting',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              type: '1', // 0: 普通安装  1：静默安装  2:壁纸下载路径
              status: data.code === 0,
            },
          }),
        );
      },
      err => {
        Toast.error({
          content: '软件静默安装路径，设置失败！',
        });
        setPathValueQuiet(quietInstallPath.installpath);
      },
    );
  }, [inputRefQuiet, quietInstallPath]);

  // 选择静默安装路径
  const handleBrowserFolderQuiet = useCallback(() => {
    const path = quietInstallPath.installpath || '';
    PCStoreJsBridge.browserFolder(path).then(res => {
      setPathValueQuiet(res.DownLoadPath);
      setTimeout(() => {
        submitQuietInstallPath();
      }, 100);
    });

    // 点击 打开选择文件路径
    dispatch(
      logging({
        category: 'C',
        action: 'Check_Path',
        label: '',
        param2: {
          source: 'Setting',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type: '1', // 0: 普通安装  1：静默安装
        },
      }),
    );
  }, [dispatch, quietInstallPath]);

  // 点击 恢复默认的静默安装路径
  const handleRecoverQuiet = useCallback(() => {
    const definstallpath = quietInstallPath.definstallpath || 'D:\\AppStoreInstalled\\';
    setPathValueQuiet(definstallpath);
    setTimeout(() => {
      submitQuietInstallPath();
    }, 100);

    // 点击 恢复默认文件路径
    dispatch(
      logging({
        category: 'C',
        action: 'Recover_Path',
        label: '',
        param2: {
          source: 'Setting',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type: '1', // 0: 普通安装  1：静默安装
        },
      }),
    );
  }, [dispatch, logInfoData]);

  // 点击 切换打开右键菜单
  const handleCheckRightMenu = useCallback(
    info => {
      const startInfo = JSON.parse(localStorage.getItem(cacheKeys.START_INFO) || '{}');
      // source: 1表示设置中心的设置，2表示关闭商店的时候的设置
      PCStoreJsBridge.settingRightMenu({
        enable: !info.enable,
        source: 1,
        wallpaperEnable: startInfo.rightMenuInfo.wallpaperEnable,
        recommendEnable: startInfo.rightMenuInfo.recommendEnable,
      }).then(ret3 => {
        if (ret3.succ === 'true') {
          setRightMenuInfo({
            ...rightMenuInfo,
            enable: !info.enable,
          });
          let Info = {
            ...startInfo,
            rightMenuInfo: {
              enable: !info.enable,
              source: 1,
              wallpaperEnable: startInfo.rightMenuInfo.wallpaperEnable,
              recommendEnable: startInfo.rightMenuInfo.recommendEnable,
              cloudEnable: true,
            },
          };
          localStorage.setItem('START_INFO', JSON.stringify(Info));
        } else {
          message.info('软件快捷方式右键添加“强力卸载此软件”选项，设置失败');
        }
      });

      // 点击 切换打开右键菜单
      dispatch(
        logging({
          category: 'C',
          action: 'Right_Menu_Cancel',
          label: '',
          param2: {
            source: 'Setting',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            enabled: !info.enable,
          },
        }),
      );
    },
    [logInfoData, rightMenuInfo],
  );

  // 自动升级设置
  const handleCheckAutoUpdate = useCallback(enabled => {
    setIsEnabledAutoUpdate(!enabled);
    // 保存自动更新商店设置
    PCStoreJsBridge.setUpdatePCStoreState({ userQuietUpgrade: !enabled });

    // 点击 切换打开升级设置
    dispatch(
      logging({
        category: 'C',
        action: 'AutoUpdate_Cancel',
        label: '',
        param2: {
          source: 'Setting',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          enabled: !enabled,
        },
      }),
    );
  }, []);

  const handleCheckClear = useCallback(enabled => {
    setIsEnabledClear(!enabled);

    // 保存自动清除安装包
    const param = {
      autoclean: !enabled ? 1 : 0,
      spanday: clearSpanDay,
    };
    PCStoreJsBridge.settingAutoClearApp(param).then(ret2 => {
      if (ret2.succ === 'true') {
        const startInfo = JSON.parse(localStorage.getItem(cacheKeys.START_INFO) || '{}');
        localStorage.setItem(cacheKeys.START_INFO, JSON.stringify({ ...startInfo, ...param }));
      } else {
        message.info('自动删除安装包设置失败');
      }
    });

    // 点击 切换打开快装
    dispatch(
      logging({
        category: 'C',
        action: 'ClearApp_Cancel',
        label: '',
        param2: {
          source: 'Setting',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          enabled: !enabled,
        },
      }),
    );
  }, []);

  /**
   * 磁铁清除
   */
  const handleCheckTile = useCallback(() => {
    setIsEnabledTileInfo({ ...isEnabledTileInfo, enable: !isEnabledTileInfo.enable });

    // 保存自动清除安装包 source为1：设置中心勾选框创建；2：关闭商店时创建；3：创建商店时创建
    PCStoreJsBridge.settingPCStoreTile({ enable: !isEnabledTileInfo.enable, source: 1 }).then(
      ret2 => {
        if (ret2.succ === true) {
          logNative(`设置卸载磁贴开关`, ret2, true, true);
        } else {
          message.info('自动删除安装包设置失败');
        }
      },
    );

    // 点击 切换打开快装
    dispatch(
      logging({
        category: 'C',
        action: 'Uninstall_Tile_Cancel',
        label: '',
        param2: {
          source: 'Setting',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          enabled: !isEnabledTileInfo.enabled,
        },
      }),
    );
  }, [isEnabledTileInfo]);

  // 点击更多设置
  const handleMoreSetting = () => {
    setFoldPanel(false);
    dispatch(
      logging({
        category: 'C',
        action: 'Set_More',
        label: '',
        param2: {
          source: 'Setting',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  };

  /**
   * 改变弹窗通知状态
   * type: 1：升级弹框，   2：右键菜单开关，   3：卸载残留弹窗开关，   4：不常用软件弹窗开关
   * enable true： 打开  false： 关闭
   * source: 1：设置中心勾选框创建；2：关闭商店时创建；3：创建商店时创
   */
  const setSwitchTypeStatus = (type, enable = true) => {
    PCStoreJsBridge.setAppStoreSwitch({
      type,
      enable,
      source: 1,
    }).then(
      res => {
        getSwitchStatus({ type });
        if (res.code !== 0 || !res.succ) {
          message.error({
            content: '设置失败！',
            icon: <img className="ant-message-custom-img" src={fail} alt="success" />,
          });
        } else {
          Toast.success({ content: '设置成功！' });
        }
      },
      () => {
        message.error({
          content: '设置失败！',
          icon: <img className="ant-message-custom-img" src={fail} alt="success" />,
        });
      },
    );
  };

  const handleSwitchEnabled = useCallback(
    type => {
      if (switchInfo[type].isEnabled) {
        setSwitchType(type);
        dispatch(
          logging({
            category: 'P',
            // action: 'Tankuang_Disable_Toast',
            action: 'Tankuang_DT',
            label: '',
            param2: {
              source: 'Setting',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              type,
            },
          }),
        );
      } else {
        setSwitchTypeStatus(type, true);
        dispatch(
          logging({
            category: 'C',
            action: 'Tankuang_Enabled',
            label: '',
            param2: {
              source: 'Setting',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              enabled: true,
              type,
            },
          }),
        );
      }
    },
    [switchInfo, isEnabledUpdate, isEnabledRight, isEnabledRarelyUse, isEnabledResidual],
  );
  // 点击X关闭
  const hanldeCloseSwitchModal = useCallback(() => {
    setSwitchType(null);
    dispatch(
      logging({
        category: 'C',
        action: 'Tankuang_DT_Close',
        label: '',
        param2: {
          source: 'Setting',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type: switchType,
        },
      }),
    );
  }, [switchType]);
  // 点击取消关闭
  const hanldeCancelSwitchModal = useCallback(() => {
    setSwitchType(null);
    dispatch(
      logging({
        category: 'C',
        action: 'Tankuang_DT_Cancel',
        label: '',
        param2: {
          source: 'Setting',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type: switchType,
        },
      }),
    );
  }, [switchType]);

  // 点击确定按钮
  const hanldeOkSwitchModal = useCallback(() => {
    setSwitchTypeStatus(switchType, false);
    setSwitchType(null);
    dispatch(
      logging({
        category: 'C',
        action: 'Tankuang_DT_Sure',
        label: '',
        param2: {
          source: 'Setting',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type: switchType,
        },
      }),
    );
  }, [switchType]);

  // 初始化 拿到系统模式
  useEffect(() => {
    if (window.external && window.external.get_gui_mode) {
      let bizParam = window.external.get_bizparam() || JSON.parse(window.external.bizparam || '{}');
      let guiMode = window.external.get_gui_mode() || '';
      let guiModeInfo = { ...bizParam, guiMode };

      setIsEnabledSystemType(guiModeInfo.guiMode === '1');
    }
  }, []);

  const handleSystemType = useCallback(() => {
    if (!timeoutSystemType) {
      timeoutSystemType = true;
      let timeoutIndex = setTimeout(() => {
        timeoutSystemType = false;
        clearTimeout(timeoutIndex);
      }, 2000);
      if (window.external && window.external.modify_gui_mode) {
        window.external.modify_gui_mode(!isEnabledSystemType ? '1' : '0');
        setIsEnabledSystemType(!isEnabledSystemType);
      }

      dispatch(
        logging({
          category: 'C',
          action: 'Tankuang_System_Type',
          label: '',
          param2: {
            source: 'Setting',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            ...systemType,
            guiMode: !isEnabledSystemType ? '0' : '1',
          },
        }),
      );
    } else {
      message.info('请勿频繁设置！');
    }
  }, [isEnabledSystemType]);

  return (
    <>
      <div className={styles.stting}>
        <div className="header">
          <div className="header_text">设置中心</div>
          <div className="icon iconfont icon-opt_close" onClick={handleCancel} />
        </div>
        <div className={classNames(styles.stting_content, { [styles.extaPadding]: foldPanel })}>
          <div className="setting_content">
            <div className="line">
              <div className="title">下载设置</div>
              <div className="content">
                <div className="desc">将下载的软件保存在以下目录：</div>
                <div className="choose">
                  <input
                    type="text"
                    className="value text-ellipsis"
                    readOnly
                    ref={inputRef}
                    value={pathValue}
                  />
                  <div className="btn" onClick={handleBrowserFolder}>
                    选择目录
                  </div>
                  <div
                    className="open"
                    onClick={() => {
                      handleOpenFolder(pathValue, '0');
                    }}
                  >
                    打开
                  </div>
                </div>
                <div className="recovery" onClick={handleRecover}>
                  恢复默认目录
                </div>
              </div>
            </div>
            <div className="line">
              <div className="title">快装设置</div>
              <div className="content">
                <div className="checkbox" onClick={() => handleCheck(isEnabled)}>
                  {isEnabled ? <div className="checked" /> : <div className="no_checked" />}
                  <span>开启快装功能</span>
                </div>
                {!isEnabled && <div className="div_disable_cover" />}
                <div className={isEnabled ? styles.div_enable : styles.div_disable}>
                  <div className="desc">将支持“快装”（一键静默安装）的软件默认安装到以下目录：</div>
                  <div className="choose">
                    <input
                      type="text"
                      className="value text-ellipsis"
                      readOnly
                      ref={inputRefQuiet}
                      value={pathValueQuiet}
                    />
                    <div className="btn" onClick={handleBrowserFolderQuiet}>
                      选择目录
                    </div>
                    <div
                      className="open"
                      onClick={() => {
                        handleOpenFolder(pathValueQuiet, '1');
                      }}
                    >
                      打开
                    </div>
                  </div>
                  <div className="recovery" onClick={handleRecoverQuiet}>
                    恢复默认目录
                  </div>
                </div>
              </div>
            </div>
            <WallpaperPath />

            <div className="line">
              <div className="title">安装包清理</div>
              <div className="content">
                <div
                  className="checkbox checkbox_clear"
                  onClick={() => handleCheckClear(isEnabledClear)}
                >
                  {isEnabledClear ? <div className="checked" /> : <div className="no_checked" />}
                  <span>下载完成{clearSpanDay}天后，自动删除安装包</span>
                </div>
              </div>
            </div>
            {isDStore && (
              <div className="line">
                <div className="title">升级设置</div>
                <div className="content">
                  <div
                    className="checkbox"
                    onClick={() => handleCheckAutoUpdate(isEnabledAutoUpdate)}
                  >
                    {isEnabledAutoUpdate ? (
                      <div className="checked" />
                    ) : (
                      <div className="no_checked" />
                    )}
                    <span>有更新时自动升级联想应用商店</span>
                  </div>
                  <div className="desc">
                    推荐开启自动升级，更早体验联想应用商店最新版本，享受极致使用体验
                  </div>
                </div>
              </div>
            )}
            {rightMenuInfo && rightMenuInfo.cloudEnable && (
              <div className="line">
                <div className="title">卸载设置</div>
                <div className="content">
                  <div
                    className="checkbox checkbox_clear"
                    onClick={() => handleCheckRightMenu(rightMenuInfo)}
                  >
                    {rightMenuInfo && rightMenuInfo.enable ? (
                      <div className="checked" />
                    ) : (
                      <div className="no_checked" />
                    )}
                    <span>软件快捷方式右键添加“强力卸载此软件”选项</span>
                  </div>
                  <div className="desc desc_margin_top">
                    开启后，将在快捷方式右键添加“强力卸载此软件”选项，一键强力卸载软件
                  </div>
                </div>
              </div>
            )}
            {/* 变态的产品需求，因为技术难度大，暂时屏蔽此功能 */}
            {false && isEnabledTileInfo && isEnabledTileInfo.cloudEnable && (
              <div className="line">
                <div className="title">磁贴</div>
                <div className="content">
                  <div className="checkbox checkbox_clear" onClick={() => handleCheckTile()}>
                    {isEnabledTileInfo.enable ? (
                      <div className="checked" />
                    ) : (
                      <div className="no_checked" />
                    )}
                    <span>开始菜单添加“卸载电脑软件</span>
                  </div>
                </div>
              </div>
            )}
            {!foldPanel && (
              <>
                <div className="line">
                  <div className="title">升级弹窗设置</div>
                  <div className="content">
                    <div
                      className="checkbox checkbox_clear"
                      onClick={() => {
                        handleSwitchEnabled(1);
                      }}
                    >
                      {isEnabledUpdate ? (
                        <div className="checked" />
                      ) : (
                        <div className="no_checked" />
                      )}
                      <span>开启升级弹窗</span>
                    </div>
                    <div className="desc desc_margin_top">
                      建议您开启升级弹窗，以免错过大牌软件更新
                    </div>
                  </div>
                </div>
                <div className="line">
                  <div className="title">不常用软件设置</div>
                  <div className="content">
                    <div
                      className="checkbox checkbox_clear"
                      onClick={() => {
                        handleSwitchEnabled(4);
                      }}
                    >
                      {isEnabledRarelyUse ? (
                        <div className="checked" />
                      ) : (
                        <div className="no_checked" />
                      )}
                      <span>开启不常用软件提醒</span>
                    </div>
                    <div className="desc desc_margin_top">
                      建议您开启不常用软件提醒，及时管理我的软件。
                    </div>
                  </div>
                </div>
                <WallpaperChange />
                <MessageHint />
                <div className="line">
                  <div className="title">卸载残留设置</div>
                  <div className="content">
                    <div
                      className="checkbox checkbox_clear"
                      onClick={() => {
                        handleSwitchEnabled(3);
                      }}
                    >
                      {isEnabledResidual ? (
                        <div className="checked" />
                      ) : (
                        <div className="no_checked" />
                      )}
                      <span>开启卸载残留提醒</span>
                    </div>
                    <div className="desc desc_margin_top">
                      建议您开启卸载残留提醒，及时清理残留，释放空间。
                    </div>
                  </div>
                </div>
                <UnknownFile />
                {/* <OpenWelcome/> */}
                {false && systemType && systemType.businessCode && (
                  <div className="line">
                    <div className="title">模式设置</div>
                    <div className="content">
                      <div
                        className="checkbox checkbox_clear"
                        onClick={() => {
                          handleSystemType();
                        }}
                      >
                        {isEnabledSystemType ? (
                          <div className="checked" />
                        ) : (
                          <div className="no_checked" />
                        )}
                        <span>开启非游戏模式</span>
                      </div>
                      <div className="desc desc_margin_top">取消选中恢复到商店默认模式</div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
          {foldPanel && (
            <div className={styles.foldPanel} onClick={handleMoreSetting}>
              更多设置
              <i className="iconfont icon-arrow_down_small" />
            </div>
          )}
        </div>
      </div>
      {switchType && (
        <Dialog containerStyle={styles.update_modal} handleClose={hanldeCloseSwitchModal}>
          <div className={styles.update_content_modal}>{switchInfo[switchType].modalInfo}</div>
          <div>
            <Btn className={styles.updaye_btn_modal} handleClick={hanldeOkSwitchModal}>
              确定
            </Btn>
            <Btn primary className={styles.updaye_btn_modal} handleClick={hanldeCancelSwitchModal}>
              取消
            </Btn>
          </div>
        </Dialog>
      )}
    </>
  );
});
